import * as React from "react";
import { Button } from "@progress/kendo-react-buttons";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { TextArea } from "@progress/kendo-react-inputs";
import { Label } from "@progress/kendo-react-labels";
import ErrorBanner from "../../components/ErrorBanner";
import { useMutateAdminOverrideWaveStatus } from "../../data/services/notificationService";
import {
  NotStarted,
  DocUploadInProgress,
  ReadyToSendNotification,
  SendNotificationInProgress,
  SendNotificationCompleted,
  SendNotificationError,
  ReadyToSendClientNotification,
  SendClientNotificationInProgress,
  SendClientNotificationError,
  SendClientNotificationCompleted,
  Disabled,
} from "./NotificationWaveDetailHelper";

const STATUS_OPTIONS = [
  { text: "Not Started", value: NotStarted },
  { text: "Step 1 Complete - Upload Documents", value: DocUploadInProgress },
  { text: "Step 2 Complete - Ready to Send Broker Notification", value: ReadyToSendNotification },
  { text: "Broker Notification In Progress", value: SendNotificationInProgress },
  { text: "Broker Notification Completed", value: SendNotificationCompleted },
  { text: "Broker Notification Error", value: SendNotificationError },
  { text: "Step 3 Complete - Ready to Send Client Notification", value: ReadyToSendClientNotification },
  { text: "Client Notification In Progress", value: SendClientNotificationInProgress },
  { text: "Client Notification Error", value: SendClientNotificationError },
  { text: "Completed", value: SendClientNotificationCompleted },
  { text: "Disabled - cancel all pending clients", value: Disabled },
];

const AdminOverrideDialog = ({ waveId, oePeriodId, currentStatus, onClose, onSuccess }) => {
  const currentOption = STATUS_OPTIONS.find((o) => o.value === currentStatus) || STATUS_OPTIONS[0];

  const [selectedStatus, setSelectedStatus] = React.useState(currentOption);
  const [reason, setReason] = React.useState("");
  const [submitted, setSubmitted] = React.useState(false);

  const useMutateAdminOverrideHandler = useMutateAdminOverrideWaveStatus();

  const handleSubmit = async () => {
    setSubmitted(true);
    try {
      await useMutateAdminOverrideHandler.mutateAsync({
        notificationWaveId: Number(waveId),
        oePeriodId,
        targetStatus: selectedStatus.value,
        reason: reason.trim(),
      });
      onSuccess();
    } catch {
      setSubmitted(false);
    }
  };

  const isSubmitDisabled = !reason || reason.trim().length < 5 || submitted;

  return (
    <Dialog title="Admin Override - Wave Status" onClose={onClose} width={500}>
      <div style={{ padding: "10px 0" }}>
        <div style={{ marginBottom: "16px", padding: "8px 12px", backgroundColor: "#fff3cd", borderRadius: "4px", fontSize: "13px" }}>
          <strong>Current status:</strong> {currentOption.text}
        </div>

        <div style={{ marginBottom: "16px" }}>
          <Label>Force wave to status</Label>
          <DropDownList
            data={STATUS_OPTIONS}
            textField="text"
            dataItemKey="value"
            value={selectedStatus}
            onChange={(e) => setSelectedStatus(e.value)}
            style={{ width: "100%" }}
          />
        </div>

        <div style={{ marginBottom: "8px" }}>
          <Label>Reason for override (required)</Label>
          <TextArea
            value={reason}
            onChange={(e) => setReason(e.value)}
            rows={3}
            placeholder="Describe why this override is needed..."
            style={{ width: "100%" }}
          />
          {reason.length > 0 && reason.trim().length < 5 && (
            <div style={{ color: "red", fontSize: "12px", marginTop: "4px" }}>
              Reason must be at least 5 characters.
            </div>
          )}
        </div>
      </div>

      <ErrorBanner handler={useMutateAdminOverrideHandler} onError={() => setSubmitted(false)} />

      <DialogActionsBar layout="end">
        <Button onClick={onClose} disabled={submitted}>
          Cancel
        </Button>
        <Button
          themeColor="error"
          onClick={handleSubmit}
          disabled={isSubmitDisabled}
        >
          Apply Override
        </Button>
      </DialogActionsBar>
    </Dialog>
  );
};

export default AdminOverrideDialog;
